import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const stats = [
  { number: '15+', label: 'Años de experiencia', icon: 'ri-award-line' },
  { number: '500+', label: 'Clientes satisfechos', icon: 'ri-user-smile-line' },
  { number: '24h', label: 'Respuesta urgente', icon: 'ri-flashlight-line' },
  { number: '100%', label: 'Garantía escrita', icon: 'ri-shield-check-line' },
];

export default function TrustBanner() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section
      ref={ref}
      className={`relative w-full py-16 md:py-20 overflow-hidden transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
    >
      {/* Subtle background image - awning on terrace */}
      <div className="absolute inset-0">
        <img
          src="/images/009-trust-banner-bg-01.webp"
          alt=""
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
      </div>

      {/* Overlay - soft warm tint to bridge between hero and dark blue section */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-100/90 to-[#0F5066]/15"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Top tagline */}
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold font-label tracking-wide mb-4">
            Tolderos de confianza en Málaga
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight max-w-3xl mx-auto">
            Tu toldo, nuestro compromiso
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mt-4 leading-relaxed">
            Más de una década reparando e instalando toldos en Málaga. Conocemos el clima, las marcas y la urgencia de tener una terraza protegida.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-white/70 backdrop-blur-md border border-background-200/60 shadow-sm hover:shadow-md hover:bg-white/80 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${stat.icon} text-primary-500 text-xl`}></i>
              </div>
              <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                {stat.number}
              </span>
              <span className="text-sm text-foreground-600 font-medium text-center leading-tight">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 pt-10 md:pt-12">
          <Link
            to="/presupuesto"
            className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-primary-500 text-white text-sm font-bold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/20 hover:shadow-primary-500/30 hover:scale-105"
          >
            <span>Solicitar presupuesto gratuito</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
          <a
            href="tel:+34951120770"
            className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-white/70 backdrop-blur-md border border-background-200/70 text-foreground-700 text-sm font-bold rounded-full hover:bg-white hover:text-primary-500 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line text-lg text-primary-500"></i>
            <span>951 12 07 70</span>
          </a>
        </div>
      </div>
    </section>
  );
}